import React from 'react'
import List from '../pages/list'

export const PagesLaLigaGroupList = (props) => <List {...props} filter={{ collection: 'laliga_group' }} title="Pages LaLiga Group" />

export default PagesLaLigaGroupList
